import React, { useState, useEffect } from "react";
import * as Styled from "./styles";
import dayjs from "dayjs";
import { listTypes, totalListTypes } from "../../../Types/employeeType";
import { phoneNumberFormatting } from "../../../middlewares";
import { SmallTitle, GOLoading } from "../../../components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface tableProps {
  data?: listTypes[];
  totalData?: totalListTypes[] | any;
  total?: boolean;
  totalCount?: number;
  startPageNumber?: number;
}

const ReservationCountTable = ({
  data,
  totalData,
  total,
  totalCount,
  startPageNumber
}: tableProps) => {
  const { t } = useTranslation();
  const [scrollPosition, setScrollPosition] = useState<number>(0);

  const statusText = (status: number) => {
    if (status === 0)
      return (
        <Styled.StatusText>
          {t("components.employee.onReservation")}
        </Styled.StatusText>
      );
    else if (status === 1)
      return (
        <Styled.StatusText checkin>
          {t("components.employee.attendance")}
        </Styled.StatusText>
      );
    else
      return (
        <Styled.StatusText absent>
          {t("components.employee.absence")}
        </Styled.StatusText>
      );
  };

  const handleScroll = () => {
    window.scrollTo(0, 0);
  };

  const onScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      {total ? (
        <>
          <Styled.Box>
            {totalData ? (
              <>
                <SmallTitle
                  body={`${t("components.employee.count")} [${totalCount}]`}
                />
                <Styled.Table>
                  <table>
                    <thead>
                      <tr>
                        <td>{t("components.employee.number")}</td>
                        <td>{t("components.employee.name")}</td>
                        <td>{t("components.employee.phone")}</td>
                        <td>{t("components.employee.startDay")}</td>
                        <td>{t("components.employee.endDay")}</td>
                        <td>{t("components.employee.membershipHeld")}</td>
                        <td>{t("components.employee.ticketType")}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {totalData.map((data: any, index: number) => (
                        <tr key={index}>
                          <td>{index + 1 + (startPageNumber || 0)}</td>
                          <td className="name">
                            <Link to={`/admin/user/${data.id}`}>
                              <Styled.Flexbox>
                                <Styled.ProfileImage
                                  style={{
                                    background:
                                      data.profileImageURL &&
                                      `url(${data.profileImageURL}) center / cover`
                                  }}
                                />
                                <div>{data.userName}</div>
                              </Styled.Flexbox>
                            </Link>
                          </td>
                          <td>{phoneNumberFormatting(data.phoneNumber)}</td>
                          <td>
                            {dayjs(data.startDate).format("YYYY. MM. DD")}
                          </td>
                          <td>{dayjs(data.endDate).format("YYYY. MM. DD")}</td>
                          <td>{data.ticketName}</td>
                          {data.isUnlimited === 1 ? (
                            <td>
                              <Styled.ResDetail>
                                {t("components.employee.unlimitedTicket")}
                              </Styled.ResDetail>
                            </td>
                          ) : (
                            <td>
                              <Styled.ResDetail total>
                                {t("components.employee.total")}:{" "}
                                {data.totalCount}
                                {t("components.employee.times")}
                              </Styled.ResDetail>
                              <Styled.ResDetail checkin>
                                {t("components.employee.used")}:{" "}
                                {data.totalCount - data.remainingCount}
                                {t("components.employee.times")}
                              </Styled.ResDetail>
                              <Styled.ResDetail remain>
                                {t("components.employee.remaining")}:{" "}
                                {data.remainingCount}
                                {t("components.employee.times")}
                              </Styled.ResDetail>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Styled.Table>
              </>
            ) : (
              <GOLoading />
            )}
          </Styled.Box>
          <Styled.Icon
            className="fas fa-arrow-circle-up"
            visible={scrollPosition > 120 ? true : false}
            onClick={handleScroll}
          />
        </>
      ) : (
        <>
          {data ? (
            <Styled.Table>
              <table>
                <thead>
                  <tr>
                    <td>{t("components.employee.number")}</td>
                    <td>{t("components.employee.name")}</td>
                    <td>{t("components.employee.phone")}</td>
                    <td>{t("components.employee.reservedDay")}</td>
                    <td>{t("components.employee.usedTicket")}</td>
                    <td>{t("components.employee.status")}</td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((d: any, index: number) => (
                    <tr key={index}>
                      <td>{index + 1 + (startPageNumber || 0)}</td>

                      <td className="name">
                        <Link to={`/admin/user/${d.userId}`}>
                          <Styled.Flexbox>
                            <Styled.ProfileImage
                              style={{
                                background:
                                  d.profileImageURL &&
                                  `url(${d.profileImageURL}) center / cover`
                              }}
                            />
                            <div> {d.userName}</div>
                          </Styled.Flexbox>
                        </Link>
                      </td>

                      <td>
                        <Link to={`/admin/user/${d.userId}`}>
                          {" "}
                          {phoneNumberFormatting(d.phoneNumber)}
                        </Link>
                      </td>
                      <td>
                        <div>{dayjs(d.startDate).format("YYYY. MM. DD")}</div>
                        <div>{`${dayjs(d.startDate).format("a h:mm")} ~ ${dayjs(
                          d.endDate
                        ).format("a h:mm")}`}</div>
                      </td>
                      <td>{d.ticketName}</td>
                      <td>{statusText(d.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Styled.Table>
          ) : (
            <GOLoading />
          )}
        </>
      )}
    </>
  );
};

export default ReservationCountTable;
